import { ProductType } from '@utils/helpers'
import { parseAsInteger, type SingleParserBuilder } from 'nuqs/server'

export type ProductTypeMask = ProductType | (number & {})

export const productTypeParser = parseAsInteger.withDefault(
  ProductType.NONE
) as SingleParserBuilder<ProductTypeMask> & {
  readonly defaultValue: ProductTypeMask
}
